<ng-container *ngIf="selectedJobId; else main">
  <app-job-order-detail
    (backClick)="onBackClick()"
    [jobOrderId]="selectedJobId"
  ></app-job-order-detail>
</ng-container>

<ng-template #main>

  <!-- ── NEW state: full-width layout ───────────────────────────────────── -->
  <ng-container *ngIf="pageState == 'NEW'">
    <div class="fc-new-job-layout">
      <p class="fc-new-job-hint">Fill all the data for the new Job Order</p>
      <app-job-order-form-component
        [jobOrder]="selectedJobOrder"
        (save)="onJobOrderDataUpdate($event)"
        (cancel)="onJobOrderUpdateCancel()"
      ></app-job-order-form-component>
    </div>
  </ng-container>

  <!-- ── IDLE / UPDATE states: sidebar + content grid ──────────────────── -->
  <ng-container *ngIf="pageState != 'NEW'">
    <div class="job-orders-container">
      <section class="leftbar">
        <app-job-order-filter-component
          *ngIf="pageState == 'IDLE'"
          (apply)="onJobOrderFilterChange($event)"
        ></app-job-order-filter-component>
        <app-job-order-data-state-filter-component
          *ngIf="pageState == 'UPDATE'"
          (apply)="onJobOrderDataStateFilterChange($event)"
          (viewAllSelected)="onViewAllSelectedDataStates()"
        ></app-job-order-data-state-filter-component>
      </section>

      <section class="rightbar">
        <app-job-order-form-component
          *ngIf="pageState == 'UPDATE'"
          [jobOrder]="selectedJobOrder"
          (save)="onJobOrderDataUpdate($event)"
          (cancel)="onJobOrderUpdateCancel()"
        ></app-job-order-form-component>

        <div *ngIf="pageState == 'IDLE'" class="job-orders-header-section">
          <button
            type="button"
            class="btn-new"
            (click)="onNewJobOrderClicked()"
          >
            New job
          </button>
        </div>

        <ng-container *ngIf="!isJobOrderDataStateLoading; else loading">
          <ng-container *ngTemplateOutlet="loaded"></ng-container>
        </ng-container>
      </section>
    </div>
  </ng-container>

  <!-- LOADED -->
  <ng-template #loaded>
    <div *ngIf="pageState == 'IDLE'">
      <app-job-order-list-component
        *ngIf="jobOrders.length; else emptyJobOrder"
        [jobOrders]="jobOrders"
        (updateClick)="onJobOrderUpdateActionClick($event)"
        (deleteClick)="onJobOrderDeleteActionClick($event)"
        (detailClick)="onJobOrderDetailActionClick($event)"
      ></app-job-order-list-component>
    </div>
    <div *ngIf="pageState == 'UPDATE'">
      <app-job-order-data-state-list-component
        *ngIf="shownDataStateElements.size; else emptyJobOrderDataState"
        [jobOrderDataStates]="shownDataStateElements"
        (dataStateCheckChanged)="onDataStateCheckChanged($event)"
      ></app-job-order-data-state-list-component>
    </div>
  </ng-template>

  <!-- LOADING -->
  <ng-template #loading>
    <div class="loading-container">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>

  <!-- EMPTY -->
  <ng-template #emptyJobOrder>
    <div class="empty">
      <mat-icon>refresh</mat-icon>
      <span>No result found, try to update the filters or to create a new job order</span>
    </div>
  </ng-template>

  <ng-template #emptyJobOrderDataState>
    <div class="empty">
      <mat-icon>refresh</mat-icon>
      <span>{{
        selectedJobOrder !== undefined
          ? "This job order hasn't any data state, you can assign one by searching using filters on left and clicking on selection flag order"
          : "Create the a job order, then you will be able to assign data states to it"
      }}</span>
    </div>
  </ng-template>

</ng-template>
